import React from 'react';
import type { FC } from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

import { TEXT_CONTENT_IDS } from '../../../../utils/element-ids';
import IconRenderer from '../../../../ui/Icons/IconRenderer';

import type { PaymentMethodChannelOptionProps } from './PaymentMethodChannelOptionProps';

const PaymentMethodChannelOption: FC<
  PaymentMethodChannelOptionProps
> = ({ type, title, icon, onClick, testId, enabled }) => {
  return (
    <Button
      onClick={() => {
        onClick(type);
      }}
      variant="outlined"
      sx={{
        width: '100%',
        minHeight: '74px',
        border: '1px solid #929496',
        borderRadius: '6px',
        backgroundColor: 'transparent',
        '@media (min-width: 0px)': {
          padding: 4,
        },
        marginBottom: 2,
        '&:hover': {
          backgroundColor: 'transparent',
        },
        '&:disabled': {
          backgroundColor: 'transparent',
          border: '1px solid #929496',
        },
      }}
      data-testid={testId}
      disabled={!enabled}
    >
      <Grid
        container
        wrap="nowrap"
        justifyContent="space-between"
        alignItems="center"
        spacing={1}
        sx={{ flexGrow: 1 }}
      >
        <Grid>
          <Grid
            container
            wrap="nowrap"
            alignItems="center"
            spacing={1}
          >
            <Grid style={{ marginTop: 2 }}>
              <Typography style={{ color: '#4B4D4F' }}>
                {icon}
              </Typography>
            </Grid>
            <Grid
              style={{ textAlign: 'left' }}
              size={12}
            >
              <Typography
                data-testid={`${type}_${TEXT_CONTENT_IDS.PAYMENT_METHOD_CHANNEL_TITLE}`}
              >
                <strong>{title}</strong>
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        {enabled ? (
          <IconRenderer
            name="navigateNext"
            testId="paymentMethodChannelNavigateNextIcon"
            style={{ color: '#4B4D4F' }}
          />
        ) : (
          <Typography
            style={{ color: '#C40000' }}
            data-testid={`${type}_${TEXT_CONTENT_IDS.PAYMENT_METHOD_CHANNEL_NOT_AVAILABLE}`}
          >
            Not available
          </Typography>
        )}
      </Grid>
    </Button>
  );
};

export default PaymentMethodChannelOption;
